export default __webpack_public_path__ + "static/0158-9cb6e23988a312d60d4f13d394b04c49.png";